import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import type { ProductionChainSearch } from "../../../../components/WMS/ProductionOrders/ProductionChainPage"
import LazyRoutePage from "../../../-LazyRoutePage"

const ProductionChainPage = lazy(
  () =>
    import("../../../../components/WMS/ProductionOrders/ProductionChainPage"),
)

const normalizeCalendarDate = (value: unknown) => {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return undefined
  }
  const [year, month, day] = value.split("-").map(Number)
  const parsed = new Date(Date.UTC(year, month - 1, day))
  return parsed.getUTCFullYear() === year &&
    parsed.getUTCMonth() === month - 1 &&
    parsed.getUTCDate() === day
    ? value
    : undefined
}

export const Route = createFileRoute("/_layout/WMS/production-orders/chain")({
  validateSearch: (search: Record<string, unknown>): ProductionChainSearch => ({
    status: typeof search.status === "string" ? search.status : undefined,
    date_from: normalizeCalendarDate(search.date_from),
    date_to: normalizeCalendarDate(search.date_to),
    product_id:
      typeof search.product_id === "string" ? search.product_id : undefined,
  }),
  component: ProductionChainRoute,
})

function ProductionChainRoute() {
  return (
    <LazyRoutePage>
      <ProductionChainPage />
    </LazyRoutePage>
  )
}
